import { render, staticRenderFns } from "./productConfiguration.html?vue&type=template&id=2cc32c20&"
import script from "./productConfiguration.vue?vue&type=script&lang=js&"
export * from "./productConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports